var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { display: "flex", "align-items": "center" } },
    [
      !_vm.isInDingTalk
        ? _c("el-tooltip", { attrs: { effect: "light", placement: "top" } }, [
            _c("div", { attrs: { slot: "content" }, slot: "content" }, [
              _vm._v("产品公告")
            ]),
            _c("div", { staticStyle: { width: "30px" } }, [
              _c("i", {
                staticClass: "el-icon-message-solid",
                staticStyle: { color: "#ffffff", "font-size": "16px" },
                on: { click: _vm.productNoticeFn }
              }),
              _c("sup", { staticStyle: { "vertical-align": "super" } }, [
                _c("span", {
                  staticStyle: {
                    width: "5px",
                    height: "5px",
                    "border-radius": "50%",
                    "background-color": "#ffffff",
                    display: "inline-block"
                  }
                })
              ])
            ])
          ])
        : _vm._e(),
      _c("div", { staticClass: "userHeader-wrap" }, [
        _vm.loginUser
          ? _c("span", { staticClass: "info" }, [
              _c(
                "span",
                { staticClass: "name", attrs: { title: _vm.getUserName } },
                [_vm._v(_vm._s(_vm.getUserName))]
              ),
              !_vm.isInDingTalk
                ? _c("i", { staticClass: "icon-arrow" })
                : _vm._e()
            ])
          : _vm._e(),
        _c("ul", [
          !_vm.isInDingTalk
            ? _c(
                "li",
                {
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.logout()
                    }
                  }
                },
                [
                  _c("span", { staticClass: "icon-exit" }),
                  _vm._v("退出登录\n        ")
                ]
              )
            : _vm._e()
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-362ac64f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-362ac64f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/header/userHeader.vue
// module id = hwR4
// module chunks = 2 3 6 8 15 16 18 19 20 21 22 25 37 72 73 137